import { SubFsmBuilder } from "little-fsm";
import { TentativeBookingCreationFsmContext } from "./TentativeBookingCreationFsmContext";
import { TentativeBookingDTO, TravellerDTO } from "../../apiclient/ApiDtos";

export type TentativeBookingCreationFsmScheme = {
    context: TentativeBookingCreationFsmContext,
    substates: [
        'showing_traveller_form',
        'creating',
        'showing_creation_error',
        'back_determining',
        'back_navigation_confirming',
        //'back_to_edit_waypoints_confirming'
    ],
    events: {
        'back_to_edit_waypoints': {},
        'back_to_search': {},
        'back_to_trip_details': {},
        'back': {},
        'back_confirmed': {},
        'back_cancelled': {},
        "create_requested": { travellerInfo: TravellerDTO },
        "creation_failed": {},
        "created": { tentativeBooking: TentativeBookingDTO },
    }
}

// just simple identity function
const $I = (x) => x;

export function tentativeBookingCreationSubFsmBuilder(): SubFsmBuilder<TentativeBookingCreationFsmScheme> {
    let subBuilder = new SubFsmBuilder<TentativeBookingCreationFsmScheme>();

    subBuilder
        .entrySubstate("showing_traveller_form")


    subBuilder.substate("showing_traveller_form")
        .transition('create_requested', 'creating', (c, e) => {
            return c.withTravellerInfo(e.travellerInfo);
        })
        .transition('back', 'back_navigation_confirming', $I)

    subBuilder.substate("back_navigation_confirming")
        .transition('back', 'showing_traveller_form', $I)
        .transition('back_cancelled', 'showing_traveller_form', $I)
        .termination('back_confirmed', $I)

    /* subBuilder.substate("back_determining")
        .termination('back_to_search', 'sea', $I)
        .transition('back_to_trip_details', 'back_navigation_confirming', $I)
        .transition('back_to_edit_waypoints', 'back_to_edit_waypoints_confirming', $I)
 */

    /* subBuilder.substate("back_to_edit_waypoints_confirming")
        .transition('back', 'showing_traveller_form', $I)
        .transition('back_cancelled', 'showing_traveller_form', $I)
        .termination('back_confirmed', $I) */

    subBuilder.substate("creating")
        .transition('creation_failed', 'showing_creation_error', $I)
        .completion('created', (c, e) => c.withTentativeBooking(e.tentativeBooking))

    subBuilder.substate("showing_creation_error")
        .transition("back", 'back_navigation_confirming', $I)

    return subBuilder;
}


